import React, { useState } from "react";

type Tprops = {
    onSelect?: any;
    defaultValue?: any;
}


function SelectProvincias({ onSelect, defaultValue }: Tprops) {
    const [selectedValue, setSelectedValue] = useState(defaultValue);

    const handleChange = (event: any) => {
        setSelectedValue(event.target.value);
        onSelect(event.target.value);
    };

    return (
        <>            
            <select 
                name="provincia" 
                id="provincia" 
                className="rounded w-full h-[50px] border-[#d0d0d0]" 
                value={selectedValue} 
                onChange={handleChange}
            >
                <option value="" disabled>
                    Seleccionar provincia
                </option>
                <option value="Buenos Aires">Buenos Aires</option>
                <option value="CABA">Ciudad Autónoma de Buenos Aires</option>
                <option value="Catamarca">Catamarca</option>
                <option value="Chaco">Chaco</option>
                <option value="Chubut">Chubut</option>
                <option value="Córdoba">Córdoba</option>
                <option value="Corrientes">Corrientes</option>
                <option value="Entre Ríos">Entre Ríos</option>
                <option value="Formosa">Formosa</option>
                <option value="Jujuy">Jujuy</option>
                <option value="La Pampa">La Pampa</option>
                <option value="La Rioja">La Rioja</option>
                <option value="Mendoza">Mendoza</option>
                <option value="Misiones">Misiones</option>
                <option value="Neuquén">Neuquén</option>
                <option value="Río Negro">Río Negro</option>
                <option value="Salta">Salta</option>
                <option value="San Juan">San Juan</option>
                <option value="San Luis">San Luis</option>
                <option value="Santa Cruz">Santa Cruz</option>
                <option value="Santa Fe">Santa Fe</option>
                <option value="Santiago del Estero">Santiago del Estero</option>
                <option value="Tierra del Fuego">Tierra del Fuego</option>
                <option value="Tucumán">Tucumán</option>
            </select>
        </>
    );
}

export default SelectProvincias;

